import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Button } from '@stratascratch/ui';
import { RotateCw, Check } from '@stratascratch/icons';
import { EditorButtonsLayout, EditorButtonsWrapper, } from './EditorButtonsLayout';
import './QueryButtonsSection.css';
const SOLUTION_BUTTON_LABEL = {
    default: 'Check Solution',
    solved: (_jsxs(_Fragment, { children: [_jsx(Check, { className: "QueryButtonsSection__solution-icon" }), "Solved"] })),
    failed: 'Check Solution',
};
const solutionStates = {
    default: 'Check Solution',
    solved: 'Solved',
    failed: 'Check Solution',
};
export const getSolutionButtonLabel = (solutionState) => {
    if (!solutionState)
        return solutionStates['default'];
    return solutionStates[solutionState];
};
// TypeScript narrow Event to KeyboardEvent
function isKeyboardEvent(event) {
    return 'key' in event;
}
function QueryButtonsSection({ disabled, isLoading, resetCode = undefined, checkSolution = undefined, runCode, solutionState, keyBindingRef = undefined, buttonsLayoutClassName = undefined, children = undefined, }) {
    var _a;
    useEffect(() => {
        const captureTarget = (keyBindingRef === null || keyBindingRef === void 0 ? void 0 : keyBindingRef.current) || document;
        function executeKeyBindings(e) {
            if (isKeyboardEvent(e) && e.altKey && e.key === 'Enter') {
                e.preventDefault();
                if (!disabled && !isLoading) {
                    runCode();
                }
            }
        }
        captureTarget.addEventListener('keydown', executeKeyBindings);
        return () => {
            captureTarget.removeEventListener('keydown', executeKeyBindings);
        };
    }, [keyBindingRef, disabled, isLoading, runCode]);
    const keyBinding = ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.includes('Mac'))
        ? '⌥ + Enter'
        : 'Alt + Enter';
    return (_jsxs(EditorButtonsLayout, { className: buttonsLayoutClassName, children: [_jsxs(EditorButtonsWrapper, { children: [resetCode && (_jsx(Button, { as: "button", variant: "outline", size: "rectangle", onClick: resetCode, disabled: isLoading || disabled, children: "Reset" })), _jsxs(Button, { as: "button", variant: "outline", size: "rectangle", onClick: runCode, disabled: isLoading || disabled, children: [_jsx(RotateCw, {}), "Run Code"] }), checkSolution && (_jsx(Button, { as: "button", variant: "primary", size: "rectangle", className: `QueryButtonsSection__solution-btn--${solutionState}`, onClick: async () => {
                            localStorage.removeItem('is_correct_solution');
                            await checkSolution();
                            if (solutionState === 'solved') {
                                localStorage.setItem('is_correct_solution', 'true');
                            }
                        }, disabled: isLoading || disabled, children: SOLUTION_BUTTON_LABEL[solutionState] ||
                            SOLUTION_BUTTON_LABEL.default }))] }), _jsxs("p", { className: "text-end !text-xs/5 text-neutral-500", children: ["Use ", keyBinding, " to run query", _jsx("br", {}), "Highlight some code to execute selection only"] }), children] }));
}
export default QueryButtonsSection;
//# sourceMappingURL=QueryButtonsSection.js.map